import { Field } from 'react-final-form'
import { format, isBefore, parse, startOfDay } from 'date-fns'

import DatePicker from 'common/components/datePicker'
import { FieldConfiguration } from 'common/components/dynamicFields/interfaces'
import FormItem from 'common/components/formItem'

const REACT_APP_DEFAULT_DATE_FORMAT = process.env.REACT_APP_DEFAULT_DATE_FORMAT

const toDateFnsFormat = (fmt: string | undefined) =>
  (fmt ?? 'dd MMM yyyy')
    .replace(/YYYY/g, 'yyyy')
    .replace(/DD/g, 'dd')
    .replace(/\bD\b/g, 'd')

const validateDate = (value: string | undefined) => {
  if (!value) {
    return 'Select a date.'
  }
}

type Props = {
  name: string
  config: FieldConfiguration
  isFocused?: boolean
  isDisabled?: boolean
  onChange?: (value: Date | null) => void
  labelClassName?: string
}

const SendDate = ({
  name,
  config,
  isFocused,
  isDisabled,
  onChange,
  labelClassName,
}: Props) => {
  return (
    <Field<string>
      name={name}
      validate={config.required ? validateDate : undefined}
    >
      {({ input, meta }) => (
        <FormItem
          label={
            labelClassName ? (
              <span className={labelClassName}>{config.label}</span>
            ) : (
              config.label
            )
          }
          htmlFor={input.name}
          error={meta.touched ? meta.error : undefined}
          className="w-full"
        >
          <DatePicker
            autoFocus={isFocused}
            onDateChange={(date) => {
              input.onChange(
                date
                  ? format(date, toDateFnsFormat(REACT_APP_DEFAULT_DATE_FORMAT))
                  : null
              )
              onChange?.(date)
            }}
            date={
              input.value
                ? parse(
                    input.value,
                    toDateFnsFormat(REACT_APP_DEFAULT_DATE_FORMAT),
                    new Date()
                  )
                : null
            }
            id={input.name}
            isOutsideRange={(date) => isBefore(date, startOfDay(new Date()))}
            numberOfMonths={1}
            onBlur={input.onBlur}
            isTodayVisible
            disabled={isDisabled}
          />
        </FormItem>
      )}
    </Field>
  )
}

export default SendDate
